import React, { useState, useCallback } from 'react';
import S from './GestionDonnees.module.scss';
import VisualisationTab from './tabs/VisualisationTab';
import ImportTab from './tabs/ImportTab';
import CorrectionTab from './tabs/CorrectionTab';

const TABS = [
  { id: 'visualisation', label: '📈 Visualisation' },
  { id: 'importation', label: '📂 Importation' },
  { id: 'correction', label: '🔧 Correction' },
];

// Initialise l'état partagé à partir des données mock (une copie éditable par capteur)

const GestionDonnees = () => {
  const [activeTab, setActiveTab] = useState('visualisation');
  const [capteurActif, setCapteurActif] = useState();
  // État partagé : toutes les données par capteur, modifiables depuis n'importe quel onglet
  const [donneesByCapteur, setDonneesByCapteur] = useState({});

  // Met à jour les données d'un capteur spécifique depuis n'importe quel onglet
  const mettreAJourDonnees = useCallback((capteurId, nouvelles) => {
    setDonneesByCapteur((prev) => ({ ...prev, [capteurId]: nouvelles }));
  }, []);

  const donneesCourantes = donneesByCapteur[capteurActif] || [];
  const anomaliesTotal = Object.values(donneesByCapteur).reduce(
    (acc, arr) => acc + arr.filter((d) => d.anomalie).length,
    0
  );

  return (
    <div className={S.container}>
      <div className={S.header}>
        <h2>Gestion des données</h2>
        <div className={S.headerRight}>
          <div className={S.legend}>
            <span className={S.legendItem}>
              <span className={S.legendDot} style={{ background: '#27ae60' }} />
              Corrigées
            </span>
            <span className={S.legendItem}>
              <span className={S.legendDot} style={{ background: '#e74c3c' }} />
              Brutes / Anomalies
            </span>
          </div>
          {anomaliesTotal > 0 && (
            <span className={S.badgeErrHeader}>
              {anomaliesTotal} anomalie(s)
            </span>
          )}
        </div>
      </div>

      <div className={S.tabs}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={[S.tab, activeTab === tab.id ? S.tabActive : ''].join(
              ' '
            )}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={S.content}>
        {activeTab === 'visualisation' && (
          <VisualisationTab
            capteurActif={capteurActif}
            setCapteurActif={setCapteurActif}
            donnees={donneesCourantes}
            onMettreAJour={(nouvelles) =>
              mettreAJourDonnees(capteurActif, nouvelles)
            }
          />
        )}
        {activeTab === 'importation' && <ImportTab />}
        {activeTab === 'correction' && (
          <CorrectionTab
            capteurActif={capteurActif}
            setCapteurActif={setCapteurActif}
            donnees={donneesCourantes}
            onMettreAJour={(nouvelles) =>
              mettreAJourDonnees(capteurActif, nouvelles)
            }
          />
        )}
      </div>
    </div>
  );
};

export default GestionDonnees;
